import Embedded from "../classes/Embedded";
const state = {
  data: {
    store: {
      lang: null
    },
    "customer-services": {
      lang: null,
      customer: null,
      amocrm: null
    },
    promo: {
      lang: null,
      widgets: []
    }
  }
};

// getters
const getters = {
  // eslint-disable-next-line no-unused-vars
  embedded: (state, state_getters, store, store_getters) => {
    return Object.keys(state.data).map(v => {
      return new Embedded(v, state.data[v]);
    });
  }
};

// actions
const actions = {};

// mutations
let setAttributValue = function(data, name, value) {
  for (let key in data) {
    if (typeof data[key][name] !== "undefined") {
      data[key][name] = value;
    }
  }
};
const mutations = {
  setData(state, data) {
    state.data = data;
  },
  setAmocrmAttr(state, data) {
    setAttributValue(state.data, "amocrm", data);
  },
  setCustomerAttr(state, data) {
    setAttributValue(state.data, "customer", data);
  },
  setLocaleAttr(state, data) {
    setAttributValue(state.data, "lang", data);
  },
  setWidgetsAttr(state, data) {
    setAttributValue(state.data, "widgets", data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
